/** Titre de panneau latéral portant sur une personne : « Libellé — Prénom Nom » (libellé seul si le nom est vide). */
export const withPersonName = (label: string, personName?: string | null): string => {
  const name = personName?.trim();
  return name ? `${label} — ${name}` : label;
};
